































































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import Draggable from 'vuedraggable'

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import {
  IWorkflowsInputCreate,
  IWorkflowsInputCreateStatus,
} from '@/api/types/request.types'
import { EEntities } from '@/types'

/* API */
import WorkflowsAPI from '@/api/modules/workflows.api'

export default Vue.extend({
  name: 'CreateWorkflowDrawer',

  components: {
    Draggable,
  },

  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    showDrawer: {
      type: Boolean,
      default: false,
    },
    makeEntityAgnostic: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      TextAssistant,
      firstStatus: {} as IWorkflowsInputCreateStatus,
      additionalStatuses: [] as IWorkflowsInputCreateStatus[],
      lastStatus: {} as IWorkflowsInputCreateStatus,
      workflowName: '',
      workflowDesc: '',
      isCreatingWorkflow: false,
      maxAdditionalStatusesAllowed: 38, // Doesn't include first and last (so 40 total)
    }
  },

  computed: {
    visible: {
      get(): Boolean {
        return this.showDrawer
      },
      set(newValue: boolean) {
        if (!newValue) {
          this.setInitialState()
        }
        this.$emit('update:showDrawer', newValue)
      },
    },
    isMailbox(): boolean {
      return this.entityType === EEntities.MAILBOXES
    },
    drawerWidthPct(): string {
      if (this.$screen.isLargeDesktop(this.$mq)) {
        return '800px'
      } else if (this.$screen.isTabletOrDesktop(this.$mq)) {
        return '75%'
      }
      return '100%'
    },
    disableSubmit(): boolean {
      // Must have at least 2 named statuses and a workflow name to submit...
      return (
        this.consolidatedStatuses.filter(s => s.name.trim() !== '').length <
          2 || this.workflowName.trim() === ''
      )
    },
    placeholderText(): string {
      return this.isMailbox
        ? 'e.g. Support workflow'
        : 'e.g. Bug tracking workflow'
    },
    btnColor(): string {
      return ColorAssistant.getEntityColor(this.entityType)
    },
    consolidatedStatuses(): IWorkflowsInputCreateStatus[] {
      return [this.firstStatus, ...this.additionalStatuses, this.lastStatus]
    },
  },

  created() {
    this.setInitialState()
  },

  methods: {
    setInitialState() {
      this.firstStatus = {
        name: 'Open',
        color: 'dodger-blue',
        isInactive: false,
      } as IWorkflowsInputCreateStatus
      this.additionalStatuses = [] as IWorkflowsInputCreateStatus[]
      this.lastStatus = {
        name: 'Closed',
        color: 'bluish-grey',
        isInactive: true,
      } as IWorkflowsInputCreateStatus
      this.workflowName = ''
      this.workflowDesc = ''
    },
    addAdditionalStatus() {
      this.additionalStatuses.push({
        name: '',
        color: ColorAssistant.DefaultStatusColorOptions,
        isInactive: false,
      })
    },
    removeAdditionalStatus(index: number) {
      this.additionalStatuses.splice(index, 1)
    },

    async createWorkflow() {
      try {
        this.isCreatingWorkflow = true
        const data = {
          name: this.workflowName,
          description: this.workflowDesc,
          projectTypeID: this.entityType === EEntities.PROJECTS ? 1 : 2,
          statuses: this.consolidatedStatuses,
        } as IWorkflowsInputCreate

        const response = await WorkflowsAPI.post_Create(data)
        this.$emit('workflow-created', response.id)
        this.visible = false
      } catch (error) {
        this.$error.emit(error)
      } finally {
        this.isCreatingWorkflow = false
      }
    },
  },
})
